<script setup lang="ts">
  import type { SeparatorProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { Separator } from 'reka-ui'
  import { cn } from '../../../lib/utils'

  // Re-inline `DataOrientation` locally to avoid the TS2883 `__VLS_export`
  // inference leak under TS 6 — reka-ui keeps the type in `dist/index3`
  // without a top-level re-export, so the generated component export can't
  // name it portably.
  type Orientation = 'vertical' | 'horizontal'
  type Props = Omit<SeparatorProps, 'orientation'> & {
    orientation?: Orientation
    class?: HTMLAttributes['class']
  }

  const props = withDefaults(defineProps<Props>(), {
    orientation: 'horizontal',
    decorative: true
  })

  const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <Separator
    data-slot="separator"
    v-bind="delegatedProps"
    :class="
      cn(
        'bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=vertical]:h-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px',
        props.class
      )
    "
  />
</template>
